import { BillingPeriodType } from '@constants/billingPeriods'
import useSWR from 'swr'

export interface GetCalculatedExtensionDateResponse {
  nextPaymentDate: string
}

export const useGetCalculatedExtensionDate = (period: BillingPeriodType) =>
  useSWR<GetCalculatedExtensionDateResponse>(
    `payments/calculate-payment-date?period=${period}`
  )
